






























































































import { Component, Prop, Vue } from "vue-property-decorator";
//  utilities
import dateHelper from "Utilities/date-helper";
import moment from "moment";
//  types
import { IndicatorData } from "@/types/dataQuality/dataQualityTable";

@Component({})
export default class DataIndicator extends Vue {
  @Prop({ type: Object }) data!: IndicatorData;

  //  @Getters
  get isNotAvailable(): boolean {
    return this.data.status === null;
  }

  get isNotCalculated(): boolean {
    return this.data.status === 0 && !this.data.detectionTime;
  }

  get hasOutliers(): boolean {
    return Boolean(this.data.status) && Number(this.data.status) > 0;
  }

  get formattedDetectionTime(): string | null {
    if (!this.data.detectionTime) return null;
    return dateHelper.getFormatedDateTimeString(this.data.detectionTime);
  }

  get hasBreakdownCounts(): boolean {
    return this.data.physicalBoundsCount !== undefined && this.data.physicalBoundsCount !== null;
  }

  get hasSmartOutliers(): boolean {
    return this.data.featureName === "ME Total Eq FO Mass Flow";
  }

  get statusColor() {
    if (!this.data) return;
    if (this.data.status === 0) return "ContentPositivePrimary";
    else if (Number(this.data.status) > 0 && Number(this.data.status) <= 10) return "ContentWarningSecondary";
    else if (Number(this.data.status) > 10) return "ContentNegativePrimary";
    else return "ContentTertiary";
  }

  get outlierValueClasses() {
    if (!this.data) return;
    if (this.data.status === 0 && !this.data.detectionTime) return "not-calculated";
    if (this.data.status === 0) return "no-outliers";
    else if (Number(this.data.status) > 0 && Number(this.data.status) <= 10) return "minor";
    else if (Number(this.data.status) > 10) return "major";
    else return "not-available";
  }

  //  @Methods
  navigateToLink(): void {
    if (!this.data.link) throw new Error("Link is undefined");
    this.$router.push(this.data.link);
  }

  getFormatedDateTimeString(timestamp: string): string {
    return dateHelper.getFormatedDateTimeString(timestamp);
  }

  duration(timestamp: string): string {
    return dateHelper.getHumanizeDuration(timestamp, moment().valueOf());
  }

  showOutliersInManageModal(): void {
    if (this.outlierValueClasses === "no-outliers" || this.outlierValueClasses === "not-available" || this.outlierValueClasses === "not-calculated") return;
    this.$emit("showOutliersInManageModal", this.data);
  }

  showTimeline(): void {
    this.$emit("showTimeline", this.data);
  }
}
